import { render, staticRenderFns } from "./rwhukdis.vue?vue&type=template&id=a0df4b96"
import script from "./rwhukdis.vue?vue&type=script&lang=js"
export * from "./rwhukdis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports